import { AASO } from 'src/interfaces/aaso.interfaces';
import { formatPhoneNumber } from 'src/utils/general';

function formatStoreName(storeName?: string) {
  if (!storeName) return 'N/A';
  return (
    storeName
      // remove numbers
      .replace(/\d+/g, '')
      // replace triple dashes (or more) with " - "
      .replace(/-{3,}/g, ' - ')
      // replace leftover dashes with spaces
      .replace(/-+/g, ' ')
      // trim extra whitespace
      .trim()
      // capitalize each word
      .replace(/\b\w/g, (char) => char.toUpperCase())
  );
}

// Replace placeholders in disclosure text with dynamic values
export function getDisclosurePlaceholders(
  user?: {
    mobile_phone?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
  } | null,
  aaso?: AASO,
) {
  return {
    '{APPLICANT_MOBILE_PHONE}': user?.mobile_phone ? formatPhoneNumber(user.mobile_phone) ?? '' : '',
    '{APPLICANT_FIRST_NAME}': user?.first_name ?? '',
    '{APPLICANT_LAST_NAME}': user?.last_name ?? '',
    '{APPLICANT_EMAIL}': user?.email ?? '',
    '{STORE_NAME}': formatStoreName(aaso?.store_name),
  };
}

export function replaceDisclosurePlaceholders(text: string, replacements: Record<string, string | undefined>): string {
  let result = text;
  for (const [key, value] of Object.entries(replacements)) {
    result = result.replace(new RegExp(key, 'g'), value ?? '');
  }
  return result;
}
